
import { writable } from 'svelte/store';
import { readable } from 'svelte/store';

	// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
	// attributes
	// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=

let sessionRefresh_IntervalTimer;

var fn_loggedIn_set;


export const loggedIn         = readable(false, (set) => { fn_loggedIn_set = set; });
export const loggedIn_account = readable(null);
export const loggedIn_session = readable(null);


	// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
	// methods
	// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=


export async function loginWithEmailPassword(uname, psw, success_callback = null ,error_callback = null) {
			// Call an authentication microservice to handle the authentication.
			const response = await fetch("https://auth.artificiality.be/dev/auth/withEmailPassword",
			{
			    method: 'POST',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'api_id': 'API_KEY',
			        'client_id': 'CLIENT_ID',
			        'client_secret': 'CLIENT_SECRET',
			        'client_session': CLIENT_SESSION,
			        'Content-Type': 'application/json',
			        'Accept': 'application/vnd.artificiality.auth.accountsession-v1+json',
//			        'Authorization': 'Bearer '+ cookies.get('JWT'),
   			    },
			    body: JSON.stringify({uname: uname, psw: psw }),
			})
			.then((response) => response.json())
			.then((data) => {
console.log(data);

						if (data.response.success) {
			  				fn_loggedIn_set(true);

							// set recursive check
	//						sessionRefresh_IntervalTimer = setInterval(function () {
//									refreshJWT(	/*success_callback*/ null ,
//															/*error_callback*/ null )
//								}, 5000);
							// invoke callback
							if ( typeof success_callback === "function"  ) 
										success_callback(true);
						} else {
							// invoke callback
							if ( typeof error_callback === "function"  ) 
										error_callback(/*exception obj*/ {type : 'exception', 
																						msg: 'something went wrong' } );
						}

			  })
			  .catch((err) => {
console.log(err);
							if ( typeof error_callback === "function"  ) 
										error_callback(/*exception obj*/ {type : 'exception', 
																						msg: 'something went wrong' } );
			})
			;

		};



export async function refreshJWT(success_callback = null ,error_callback = null) {
console.log('refreshJWT: async function(success_callback , error_callback )');

			// Call an authenication microservice to handle the authentication.
			const response = await fetch("https://auth.artificiality.be/dev/auth/session_token/refresh",
			{
			    method: 'GET',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'api_id': 'API_KEY',
			        'client_id': 'CLIENT_ID',
			        'client_secret': 'CLIENT_SECRET',
			        'client_session': CLIENT_SESSION,
			        'Content-Type': 'application/json',
			        'Accept': 'application/vnd.artificiality.auth.accountsession-v1+json',
//			        'Authorization': 'Bearer '+ cookies.get('JWT'),		        
			    },
			    body: JSON.stringify(),
			})
			.then((response) => response.json())
			.then((data) => {

						if (data.response.success) {
			  				fn_loggedIn_set(true);
							// invoke callback
							if ( typeof success_callback === "function"  ) 
										success_callback(true);
						} else {
			  				fn_loggedIn_set(false);
							// stop recursive check
							clearInterval(sessionRefresh_IntervalTimer);

							// invoke callback
							if ( typeof error_callback === "function"  ) 
										error_callback(/*exception obj*/ {type : 'exception', 
																						msg: 'something went wrong' } );
						}

			  })
			  .catch((err) => {
							if ( typeof error_callback === "function"  ) 
										error_callback(/*exception obj*/ {type : 'exception', 
																						msg: 'something went wrong' } );
			})
			;

	};
	

export async function logOut (success_callback = null ,error_callback = null) {
		console.log("action logout");
			// Call an authentication microservice to handle the authentication.
			const response = await fetch("https://auth.artificiality.be/dev/auth/session_token/destroy",
			{
			    method: 'DELETE',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'api_id': 'API_KEY',
			        'client_id': 'CLIENT_ID',
			        'client_secret': 'CLIENT_SECRET',
			        'client_session': CLIENT_SESSION,
			        'Content-Type': 'application/json',
			        'Accept': 'application/vnd.artificiality.auth.accountsession-v1+json',
//			        'Authorization': 'Bearer '+ cookies.get('JWT'),
   			    },
			    body: JSON.stringify( ),
			})
			.then((response) => response.json())
			.then((data) => {

						if (data.response.success) {
			  				fn_loggedIn_set(false);

							// invoke callback
							if ( typeof success_callback === "function"  ) 
										success_callback(true);
						} else {
							// invoke callback
							if ( typeof error_callback === "function"  ) 
										error_callback(/*exception obj*/ {type : 'exception', 
																						msg: 'something went wrong' } );
						}

			  })
			  .catch((err) => {
							if ( typeof error_callback === "function"  ) 
										error_callback(/*exception obj*/ {type : 'exception', 
																						msg: 'something went wrong' } );
			})
			;		
	};

